


import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import { Layer } from './LayeringEngine.models';
import CrossfadeResponsiveImage from '../utils/CrossfadeResponsiveImage/index.vue';

@Component({
  components: {
    CrossfadeResponsiveImage
  }
})
export default class LayeringEngine extends Vue {
  @Ref('layerEl') private layerEls!: CrossfadeResponsiveImage[];
  @Ref('baseLayerEl') private baseLayerEl!: CrossfadeResponsiveImage;

  @Prop({ default: false }) private simpleMode!: boolean;
  @Prop() private base!: Layer;
  @Prop() private layers!: Layer[];
  @Prop() private activeLayerID!: string;

  private initiallyLoaded = false;

  private mounted() {
    this.initiallyLoaded = !this.loading;
  }

  private onLoad() {
    if (!this.initiallyLoaded) {
      this.initiallyLoaded = !this.loading;
    }

    this.$emit(this.loading ? 'loading' : 'load');
  }

  private get loading(): boolean {
    return !![...this.layerEls, this.baseLayerEl].filter(layer => layer && !layer.crashed && !layer.loaded).length;
  }
}
